export const RU = {
  "general.search": "Поиск",

  //HEADER
  "header.time": "Московское время",

  //HOME PAGE
  "menu.about": "О нас",
  "menu.locations": "Наши дата-центры",
  "menu.transportation": "Доставка",
  "menu.contacts": "Контакты",
  "menu.call": "Заказать звонок",
  "menu.sign": "Регистрация",
  "menu.login": "Войти",
  "menu.machines": "Майнеры",
  "menu.spareparts": "Запчасти",
  "menu.clients": "Пользователи",
  "menu.settings": "Настройки",
  "menu.locations_login": "Локации",
  "menu.managment": "Менеджмент",
  "menu.messenger": "Мессенджер",
  "menu.notifications": "Уведомления",
  "menu.login_account": "Личный кабинет",
  "menu.login_logout": "Выход",
  "main.title.bold": "Майнинг отель",
  "main.title": "размещение любого вида ASIC-оборудования",
  "main.who.1": "Кто мы?",
  "main.who.2": "Что мы делаем?",
  "main.who.btn": "Читать",
  "calc.title.bold": "Рассчитать",
  "calc.reset": "Сброс",
  "calc.title": "прибыль",
  "calc.miner": "Выберите модель",
  "calc.algo": "Калькуляционный алгоритм",
  "calc.curr": "руб.",
  "calc.el": "Цена за электричество (руб./кВтч):",
  "calc.perf": "Вычислительная мощность:",
  "calc.perf.err": "C погрешностью:",
  "calc.efficiency": "Эффективность майнера:",
  "calc.efficiency.bage": "TH/кВт",
  "calc.err": "Погрешность:",
  "calc.revenue": "Ваш доход (руб.):",
  "calc.cons": "Потребление:",
  "calc.cons.bage": "кВтч",
  "calc.income": "Ваш доход после расходов за электричество (руб.):",
  "calc.add": "Добавить другое устройство",
  "calc.save": "Сохранить",
  "calc.day": "день",
  "main.contact.btn": "Оставить заявку",
  "main.subscribe": "Подписаться",

  "banner1.bold": "У нас выгодно!",
  "banner1.title": "Экономия 30% при размещении оборудования у нас.",
  "banner2.bold": "Хостинг",
  "banner2.title": "с одним из самых надежных производителей электроэнергии.",
  "banner3.bold": "С нами",
  "banner3.title":
    "ваши ASIC майнеры будут генерируйте стабильную прибыль с самого начала.",
  "banner4.bold": "Посмотрите,",
  "banner4.title": "как далеко могут зайти ваши инвестиции",

  "review1.subtitle": "Инвестор",
  "review1.descr":
    "У меня уже было несколько майнеров в Казахстане, но я решил сменить местоположение. Мой контракт истекал, и я также боялся гражданских беспорядков. Эти ребята помогли мне переместить оборудование, и пока все идет хорошо.",
  "review1.main.bold": "Наше исследование показало,",
  "review1.main.span": "что",
  "review1.main.text":
    "в среднем компании по размещению майнеров взимают со своих пользователей от 5 до 5,5 рублей за киловатт (включая техническое обслуживание), в то время как мы предлагаем размещение всего за 4,1 рублей / кВтч. Это на 30% дешевле! Только те, у кого самые низкие затраты на электроэнергию, переживут депрессивные рыночные тенденции и возрастающие трудности, а это означает, что добыча биткоина в районах с самым дешевым электричеством представляет собой хорошую и не очень долгосрочную возможность. Это может стать вашим конкурентным преимуществом перед другими майнерами.",
  "review2.subtitle": "Директор майнинг департамента",
  "review2.descr":
    "Я размещаю машины в этом майнинг отеле уже почти год, и у меня не было никаких проблем. Похоже, у них нет бюджетных ограничений, как у многих небольших компаний, поэтому у них всегда достаточно людей на местах. Я планирую увеличить количество машин в этом году.",
  "review2.main.bold": "Мы не являемся посредниками,",
  "review2.main.text":
    "как многие в этом направлении. Мы являемся авторизованным партнером второй по величине частной генерирующей компании в России, эта компания является частью более крупного холдинга, созданного более 20 лет назад. Наши планы расширения включают увеличение мощности по добыче криптовалют до 50 МВт в 2022 году. Наш 5-летний план состоит в том, чтобы к 2027 году обеспечить доступ к 2000 МВт. Все объекты защищены вооруженной охраной, оснащены камерами наблюдения и укомплектованы инженерами для выполнения регулярных процедур технического обслуживания, в которых нуждается оборудование. Все электростанции расположены в Сибири, где уникальные климатические условия позволяют охлаждать ваше оборудование при температуре около +2 °C, что продлевает срок его службы. Гидроэлектростанции играют большую роль в регионе и помогают сократить углеродный след – 60% электроэнергии, произведенной в Сибири в прошлом году, было получено из возобновляемых источников.   ",
  "review3.subtitle": "Профессиональный криптовалютный майнер",
  "review3.descr":
    "Сначала я разместил всего 10 майнеров. Через некоторое время я продал их своим друзьям с небольшой выгодой, купил еще 10, а затем снова продал их. Теперь у меня есть 47шт. Antminer S19, которые я уже разместил у вас. Я боялся продавать свое оборудование, но один из менеджеров вашей компании предложил мне попробовать, и это действительно сработало, спасибо! Отличный совет.",
  "review3.main.bold": "Мы создали решение,",
  "review3.main.text":
    "которое позволяет вам инвестировать в майнинг криптовалют, не переплачивая за электричество. Наш отель для майнинга не ограничивается местом на полке и розеткой, мы можем помочь вам выбрать оборудование, проконсультировать вас по вопросам налогообложения и предложить различные пути инвестирования.",
  "review4.subtitle": "Инвестор",
  "review4.descr":
    "Сначала я отправил несколько машин, которые валялись на моем складе в Гонконге. Затем я решил увеличить свой объем и купил оборудование непосредственно в России, потому что цена была такой же, как если бы я покупал в Китае. Ребята помогли купить устройства в Москве и отправили их в Сибирь для установки. Сделка прошла гладко и без особых задержек.",
  "review4.main.bold": "",
  "review4.main.text": "",
  //
  "last_review.title.bold": "Знаете ли вы,",
  "last_review.title.text":
    "что мы можем купить и установить майнеры для вас? Никакого опыта не требуется! Вы можете инвестировать в покупку оборудования через нашу компанию.",
  "last_review.calc.text": "Основные расчеты:",
  "last_review.calc.list1":
    "100 кВт*ч по цене 4,5 руб. составляют 324 тыс. руб. в месяц.",
  "last_review.calc.list2": `100 кВт *ч могут покрыть 30 машин "Antminer S19" (95Th/s): это означает инвестирование примерно 24 млн. руб. в новое оборудование (цена меняется в зависимости от рынка). Эта конкретная модель будет в порядке в течение следующих пяти лет.
  `,
  "last_review.calc.list3":
    "Если у вас есть собственные майнеры, мы будем более чем рады помочь с доставкой и таможенными вопросами.",
  "last_review.calc.list4": `При том, что цена биткоина остается на уровне ~ 45 000 долларов, а общий хешрейт сети составляет 185,85 EH / s, каждый майнер может приносить примерно 37866 рублей в месяц после электрических зарядов. Все 30 майнеров будут приносить общий доход в размере 1 135 980 руб. в месяц. Вам потребуется 22 месяца, чтобы достичь точки безубыточности.
  `,

  "last_review.calc.list5": `Возврат денег так быстро возможен благодаря дешевому и стабильному электроснабжению. Это лучшее соотношение цены и качества среди всех инвестиционных возможностей, поскольку многие отели для майнинга предоставляют такие тарифы только инвесторам с объемами в несколько МВт.
  `,

  "accordion.title.bold": "Что",
  "accordion.title.text": "еще мы предлагаем?",
  //
  "accordion.1.title.bold": "Гибкие",
  "accordion.1.title.text": "условия оплаты",
  "accordion.1.descr":
    "В то время как большинство майнинговых компаний просят вас оставить страховой депозит и оплатить 1-й месяц авансом, у нас вы можете просто оплачивать электроэнергию из доходов от майнинга.",
  "accordion.2.title.bold": "Гибкие",
  "accordion.2.title.text": "условия предоставления хостинга",
  "accordion.2.descr":
    "Обычно средний срок действия контракта составляет 1 год. Если вы, вдруг, задумались о чем-то другом. Поговорите с нами, и мы постараемся адаптироваться к вашим потребностям.",
  "accordion.3.title.bold": "Техническое",
  "accordion.3.title.text": "обслуживание оборудования",
  "accordion.3.descr":
    "Уборка и базовое техническое обслуживание включены в вашу цену за кВтч.",
  "accordion.4.title.bold": "Ремонт",
  "accordion.4.title.text": "оборудования",
  "accordion.4.descr":
    "У нас есть собственный сервисный центр и надежные партнеры, чтобы обеспечить более быстрые сроки выполнения работ. Ремонт как и запчасти не входят в тариф, а значит это относится к дополнительным платным услугам.",
  "accordion.5.title.bold": "Денежные",
  "accordion.5.title.text": "инвестиции",
  "accordion.5.descr":
    "Даже если у вас нет оборудования, но вы хотите начать майнить, вы все равно можете рассчитывать на нас. Мы принимаем денежные переводы, которые мы используем для покупки майнеров и транспортировки их в наши специализированные дата-центры. В зависимости от ситуации на рынке мы покупаем майнеры напрямую из Китая (с контролем качества, выполняемым нашими агентами в Шэньчжэне) или в России (с контролем качества, выполняемым нашими агентами в Москве).",
  "accordion.6.title.bold": "Помощь",
  "accordion.6.title.text": "с таможней и транспортировкой",
  "accordion.6.descr":
    "Мы будем рады сделать все возможное и помочь вам, чтобы ускорить процесс отправки вашего оборудования к нам.",
  "accordion.7.title.bold": "Продажа",
  "accordion.7.title.text": "установленных майнеров",
  "accordion.7.descr":
    "Мы будем рады заключить сделку между вами и другим майнером, который желает расширить свой объем, купив у вас оборудование. Всякий раз, когда вы решите продать, отправьте нам сообщение, и мы проверим цены на местном рынке и предложим справедливое количество.",
  "accordion.8.title.bold": "Покупка",
  "accordion.8.title.text": "установленных майнеров",
  "accordion.8.descr":
    "Если вы хотите приобрести оборудование, не ждите, просто спросите нас и мы подберем вам доступные предложения, исходя из ваших предпочтений.",
  "accordion.9.title.bold": "Перемещение",
  "accordion.9.title.text": "устройств",
  "accordion.9.descr":
    "Независимо от того, решите ли вы отправить свои машины на другую площадку или за границу, мы здесь, чтобы помочь вам. В зависимости от условий вашего контракта вы можете прекратить операции с предварительным уведомлением и попросить нас отправить машины в другое место.",
  "options.title.bold": "Выберите",
  "options.title": "способ размещения ваших устройств",
  "options.subtitle": `Мы предлагаем несколько вариантов. В зависимости от ваших потребностей вы можете разместить свое оборудование на полках в специализированном здании или снаружи в контейнере.`,

  "locations.title.bold": "Наши дата-центры",

  "location.rental": "Тариф",
  "location.rental.cost": "от 4,10 руб. за кВтч.",
  "location.cap.total.title": "Общая планируемая мощность",
  // только для Черногоска
  "location.cap.total.title-4ernogorsk": "Общая мощность",
  //
  "location.curr.cap.title": "Текущая мощность",
  "location.cap.currency": "МВт",
  "location.cap.title": "Свободная мощность",
  "location.connection.title": "Питание",
  "location.connection.text": "220 В / 380 В",
  //
  "locations.1.title": "1. Красноярск",
  "locations.1.cap": "90 МВт",
  "locations.2.title": "2. Кемерово",
  "locations.2.cap": "50 МВт",
  "locations.3.title": "3 Красноярск",
  "locations.3.cap": "20 МВт",
  "locations.4.title": "4 Красноярск",
  "locations.4.cap": "60 МВт",
  "locations.5.title": "5 Сосновоборск",
  "locations.5.cap": "100 МВт",
  "locations.6.title": "3. Черногорск",
  "locations.6.cap": "8 МВт",

  "locations.scheme.miners_start":
    "Вы уверены что хотите запустить # майнеров?",
  "locations.scheme.miners_stop":
    "Вы уверены что хотите остановить # майнеров?",
  "locations.scheme.miners_restart":
    "Вы уверены что хотите перезапустить # майнеров?",

  "locations.scheme.one_miner_start":
    "Вы уверены что хотите запустить майнер #?",
  "locations.scheme.one_miner_stop":
    "Вы уверены что хотите остановить майнер #?",
  "locations.scheme.one_miner_restart":
    "Вы уверены что хотите перезапустить майнер #?",

  "location.diagram.title": "Диаграмма соединений",
  "location.diagram.clear_field": "Очистить",
  "location.diagram.undo": "Отменить",
  "location.diagram.redo": "Повторить",
  "location.diagram.save": "Сохранить",
  "location.diagram.reload": "Перезагрузить",
  "location.diagram.cell_element": "элемент",
  "location.diagram.transformer_element": "трансформатор",
  "location.diagram.counter_element": "счетчик",
  "location.diagram.shield_element": "щит",
  "location.diagram.consumer_element": "потребитель",
  "location.diagram.network_element": "_",
  "location.diagram.rack": "Шкаф",
  "location.diagram.section": "Ячейка",
  "location.diagram.building": "Строение",
  //'cell' | 'transformer' | 'counter' | 'shield' | 'consumer' | 'network' | 'building' | "square" | "triangle" | "circle" | "diamond"
  "location.diagram.type_cell": "Элемент",
  "location.diagram.type_transformer": "Трансформатор",
  "location.diagram.type_counter": "Счетчик",
  "location.diagram.type_shield": "Щит",
  "location.diagram.type_consumer": "Потребитель",
  "location.diagram.type_network": "Сетевой элемент",
  "location.diagram.type_building": "Строение",
  "location.diagram.type_square": "Квадрат",
  "location.diagram.type_triangle": "Треугольник",
  "location.diagram.type_circle": "Круг",
  "location.diagram.type_diamond": "Ромб",
  "location.diagram.refresh": "Обновить",
  "location.diagram.node_action.reset": "Ребут",
  "location.diagram.node_action.edit": "Редактировать",
  "location.diagram.node_action.delete": "Удалить",
  "location.diagram.node_action.start": "Старт",
  "location.diagram.node_action.stop": "Стоп",
  "location.diagram.node_action.turn_on": "Включить",
  "location.diagram.node_action.turn_off": "Выключить",
  "location.diagram.unlock_to_drop": "Схема заблокирована. Разблокируйте редактирование, чтобы добавить элемент.",

  "if_you.title.bold": "Если у вас",
  "if_you.title": "нет оборудования",
  //
  "option.1.main.title": "Вариант 1",
  "option.1.title.bold": "Приобретите",
  "option.1.title.text": "предварительно установленное оборудование.",
  "option.1.descr.bold": "Иногда мы предлагаем",
  "option.1.descr": `предустановленные майнеры на продажу. Они могут поступать от других пользователей или из нашего пулла. Если вы заинтересованы, мы вышлем вам информацию о том, что доступно, сделаем фотографии и видеозаписи оборудования, а также предоставим вам серийные номера, чтобы вы могли принять обоснованное решение.`,
  "option.2.main.title": "Вариант 2",
  "option.2.title.bold": "Приобретите",
  "option.2.title.text": "машины у дистрибьюторов.",
  "option.2.descr.bold": "Мы работаем",
  "option.2.descr": `уже достаточно долго в сфере Crypto, чтобы знать всех основных дистрибьюторов в Китае. Если у вас большой заказ, вы можете получить выгодную цену и более быстрое время доставки по сравнению с официальными каналами. Из-за нестабильности рынка мы не можем указать здесь цены, но мы будем рады сообщить вам их по электронной почте или через мессенджер по вашему выбору.`,
  "have_equipment.title.bold": "Если уже",
  "have_equipment.title": "есть оборудование",
  "main.bottom.btn": "Свяжитесь с нами по всем вопросам",

  //COMMAND STATUS
  "command.status.unknown": "Неизвестно",
  "command.status.new": "Новая",
  "command.status.sending": "Отправляется",
  "command.status.pending": "В ожидании",
  "command.status.done": "Выполнена",
  "command.status.error": "Ошибка",
  "command.status.unavailable": "Недоступна",

  //LOGIN PAGE
  "login.title": "Войти",
  "login.email": "Эл. почта",
  "login.password": "Пароль",
  "login.btn": "Войти",
  "login.forgot": "Забыли пароль?",
  //
  "registration.title": "Зарегистрироваться",
  "registration.already": "Уже есть аккаунт? Нажмите",
  "registration.email": "Эл. почта",
  "registration.password": "Пароль",
  "registration.repeat": "Повторите пароль",
  "registration.policy": "Я соглашаюсь со всеми {link} сайта.",
  "registration.policy.link": "правилами",
  "registration.btn": "Создать аккаунт",

  //WLP 202603
  "wlp.header.videoReviews": "Видеообзоры",
  "wlp.header.benefits": "Наши преимущества",
  "wlp.header.contact": "Связаться с нами",
  "wlp.auth.description":
    "Введите данные вашей учетной записи, чтобы получить доступ к панели мониторинга.",
  "wlp.hashrate.title": "Недавний хешрейт",
  "wlp.hashrate.activeMiners": "2205 активных майнеров подключены к площадке",
  "wlp.hashrate.activeMinersSuffix": "активных майнеров подключены к площадке",
  "wlp.hashrate.timePeriod": "Период времени",
  "wlp.reviews.heading": "Видеообзоры",
  "wlp.reviews.1": "Недавний хешрейт и изменения состояний во времени",
  "wlp.reviews.2": "Настройки и фильтры",
  "wlp.reviews.3": "Все майнеры и вкладки",
  "wlp.reviews.4": "Технические ошибки и профиль майнера",
  "wlp.reviews.5": "Множественный выбор майнеров и управление",
  "wlp.reviews.6": "Настройки пулов и статусы",
  "wlp.reviews.7": "Модели майнеров и расписания сна",
  "wlp.reviews.8": "Управление клиентами и статистика",
  "wlp.reviews.9": "Excel-отчет и расчет аптайма",
  "wlp.reviews.10": "Локации и их статистика",
  "wlp.benefits.heading": "Наши преимущества",
  "wlp.benefits.1.title": "Бесплатная система управления майнерами",
  "wlp.benefits.1.description":
    "В отличие от традиционных платформ управления майнингом с высокой стоимостью, WattLord предоставляет бесплатную систему мониторинга с премиальными функциями для своих клиентов. Это снижает операционные расходы, поскольку базовые инструменты не требуют отдельной оплаты.",
  "wlp.benefits.2.title": "Продвинутые инструменты для крупных майнинг-ферм",
  "wlp.benefits.2.description":
    "Платформа включает уникальные функции: визуальное размещение майнеров на полках, NFC-метки для отметок электриков на точках обхода и другие инструменты, которые повышают управляемость и контроль на больших площадках.",
  "wlp.benefits.3.title": "Оптимальный выбор пула и маршрутизации",
  "wlp.benefits.3.description":
    "Система позволяет операторам видеть фактический хешрейт и выбирать конечный пул прямо из панели управления в один клик, избегая неэффективных пулов и скрытых комиссий и тем самым увеличивая доходность.",
  "wlp.benefits.4.title": "Масштабируемая и надежная инфраструктура",
  "wlp.benefits.4.description":
    "WattLord использует географически распределенную инфраструктуру, обеспечивая низкую задержку, резервирование и высокий аптайм для непрерывной работы майнинга.",
  "wlp.benefits.5.title": "Подробные Excel-отчеты",
  "wlp.benefits.5.description":
    "Операторы колокации могут формировать для клиентов подробные Excel-отчеты с анализом хешрейта за выбранный период. В них можно увидеть точные даты и время остановок, просадок хешрейта, длительность работы и простоя, среднюю скорость и аптайм по каждому клиенту отдельно.",
  "wlp.benefits.6.title": "Календари остановки и буста",
  "wlp.benefits.6.description":
    "Майнеры можно переводить в спящий режим в выбранные дни и часы для соответствия тарифным условиям и снижения энергопотребления. Также их можно бустить в периоды, когда погодные условия и стоимость электроэнергии наиболее выгодны.",
  "wlp.subscribe.title": "Рассылка",
  "wlp.subscribe.emailLabel": "Эл. почта",
  "wlp.subscribe.emailPlaceholder": "Введите вашу эл. почту",
  "wlp.subscribe.button": "Подписаться",
  "wlp.subscribe.success": "Вы успешно подписались на рассылку",
  "wlp.contact.title": "Связаться с нами",
  "wlp.contact.emailLabel": "Эл. почта",
  "wlp.contact.emailPlaceholder": "Введите вашу эл. почту",
  "wlp.contact.messageLabel": "Сообщение",
  "wlp.contact.messagePlaceholder": "Введите ваше сообщение",
  "wlp.contact.send": "Отправить",
  "wlp.contact.success": "Ваше сообщение успешно отправлено",
  "wlp.form.emailRequired": "Укажите эл. почту",
  "wlp.form.emailInvalid": "Введите корректный email",
  "wlp.form.messageRequired": "Введите сообщение",
  "wlp.form.recaptchaRequired": "Подтвердите, что вы не робот",
  "wlp.form.genericError": "Что-то пошло не так. Попробуйте позже",
  "wlp.footer.terms": "Условия использования",
  "wlp.footer.privacy": "Политика конфиденциальности",
  "wlp.footer.cookie": "Политика cookie",
  "wlp.footer.refund": "Политика возврата",
  "wlp.footer.acceptable": "Правила допустимого использования",
  "wlp.footer.disclaimer": "Отказ от ответственности",
  "wlp.footer.contact": "Связаться с нами",
  "wlp.footer.copy": "© 2026 Все права защищены",

  //MACHINES PAGE
  "machines.title": "Майнеры",
  "machines.minersSection": "Майнеры",
  "machines.summary_btns.hash": "Хэшрейт",
  "machines.summary_btns.state": "Состояния",
  "machines.summary.hash": "Хэшрейт",
  "machines.summary.state": "Состояния",
  "machines.chart.swicher.admin_and_users": "Админ и пользователи",
  "machines.chart.swicher.admin_only": "Только админ",
  "machines.chart.settingsBtns": "Выбрать настройки или алгоритм",
  "machines.chart.settings": "Настройки",
  "machines.chart.algorithms": "Алгоритмы",
  "machines.filtersAndSettings.filters": "Фильтры",
  "machines.filtersAndSettings.settings": "Настройки",
  "machines.minerSettings.show": "Настройки майнеров",
  "machines.minerSettings.hide": "Скрыть настройки",
  "machines.settings.speed_drops1": `если скорость`,
  "machines.settings.speed_drops2": `упадет ниже`,
  "machines.settings.from_speed_default": "от 'Скорости (номинальной)'",
  "machines.settings.notify_by": "Уведомлять по:",
  "machines.settings.apply_btn": "Принять",
  "machines.settings.all_errors_clear": "Очистить все ошибки",
  "machines.start_stop": "Команды",
  "machines.start_stop.start": "Старт",
  "machines.start_stop.stop": "Стоп",
  "machines.start_stop.reset": "Сброс",
  "machines.start_stop.restart": "Рестарт",
  "machines.start_stop.booston.title": "Включить разгон",
  "machines.start_stop.boostoff.title": "Выключить разгон",
  "machines.start_stop.check.title": "Проверка майнера",
  "machines.start_stop.clear_errors": "Очистить ошибки",
  "machines.add_miner": "+ Добавить новый майнер",
  "machines.add_default_miner": "Без настроек",
  "machines.add_cloned_miner": "С клонированными настройками",
  "machines.settings.pool_name": "Сменить настройки пула на",
  "machines.settings.customer": "Владелец",
  "machines.settings.type": "Тип",
  "machines.settings.location": "Локация",
  "machines.settings.speed_default": "Скорость (номинальная)",
  "machines.settings.admin_income": "Процент майнинга на админа",
  "machines.settings.adminMiningPool": "Пул майнинга на админа",
  "machines.settings.plan": "План майнинга",
  "machines.settings.miner_name": "Имя майнера",
  "machines.settings.miner_id": "ID майнера",
  "machines.admin_mining": "Майнинг на админа",
  "machines.admin_mining.various": "Несколько окон для майнинга",
  "machines.smooth_switch": "Сглаживание графика",
  "machines.settings.speed_drop_notif":
    "Уведомлять если скорость упадёт ниже чем на",
  "machines.settings.num_miners": "Следующие изменения коснутся # майнеров:",
  //
  "chosen_miners.title_main": "Майнеры",
  "chosen_miners.title": "Общее количество выбранных майнеров",
  "chosen_miners.total": "Всего:",
  "chosen_miners.id": "ID",
  "chosen_miners.type": "Тип",
  "chosen_miners.clear": "Очистить",
  "chosen_miners.hint.clear": "Очистите чтобы применить новые параметры поиска",

  //filters
  "filters.clear": "Очистить",
  "filters.title": "Отфильтруйте результаты по следующим параметрам",
  "filters.mining_admin.title": "Майнинг на админа",
  "filters.mining_admin.now": "Выполняется майнинг на админа",
  "filters.miner_errors.title": "Майнеры с ошибками",
  "filters.miner_errors.value": "Отобразить майнеры с ошибками",
  "filters.withoutflag.value": "Майнеры без флагов",
  "filters.flag.title": "Флаг майнера",
  "filters.withoutplan.value": "Майнеры без планов",
  "filters.withoutcontract.value": "Майнеры без контрактов",
  "filters.mining_admin.setting": "Настройка включена",
  "filters.pool": "Настройки пулов",
  "filters.customer": "Владелец",
  "filters.mining_percent": "Процент майнинга на админа",
  "filters.speed_less": "Текущая скорость МЕНЬШЕ чем",
  "filters.speed_more": "Текущая скорость БОЛЬШЕ чем",
  "filters.default_speed.more": "Номинальная скорость БОЛЬШЕ",
  "filters.default_speed.less": "Номинальная скорость МЕНЬШЕ",
  "filters.instalation_date_less": "От даты установки",
  "filters.instalation_date_more": "До даты установки",
  "filters.speed_drop": "Процент снижения скорости",
  "filters.type": "Тип майнера",
  "filters.contract": "Контракт",
  "filters.plans": "План",
  "filters.plan": "План майнинга",
  "filters.state": "Состояние майнера",
  "filters.algo": "Алгоритм майнинга",
  "filters.location": "Локация",
  "filters.tags.title": "Тэги клиента:",
  "filters.buildings.title": "Строения:",
  "filters.date_range.error": "Неверный диапазон дат",

  //miners table
  "machines.table.user_ports_list": "Список портов",
  "machines.table.all": "Все",
  "machines.table.id": "ID",
  "machines.table.type": "Тип",
  "machines.table.algo": "Алгоритм",
  "machines.table.speed_default": "Скорость (номинальная)",
  "machines.table.speed_current": "Скорость (текущая)",
  "machines.table.pool_settings": "Настройки пула",
  "machines.table.state": "Состояние",
  "machines.table.locations": "Локации",
  "machines.table.locations.empty": "Нет локации",
  "machines.table.customer": "Клиент",
  "machines.table.empty": "Нет майнеров",

  "machines.table.unknown.created": "Время создания",
  "machines.table.unknown.login": "Логин",
  "machines.table.unknown.agent": "Программный агент",
  "machines.table.unknown.ip": "Адрес IP",
  "machines.table.unknown.mac": "Адрес MAC",
  "machines.table.warning":
    "При переносе в данную вкладку ID майнера меняется. Это изменение будет замечено системой после ребута майнера.",

  //connect/delete miner hints
  "machines.hint.connect": "Настройки прокси для майнера",
  "machines.hint.delete": "Удалить майнер",
  "machines.hint.configure": "Настроить майнер",
  "machines.hint.deselect_all":
    "Снимите выделение всех майнеров чтобы применить новые параметры",
  "machines.hint.miner_qr": "QR код майнера",
  "machines.hint.minerId": "ID майнера",

  "machines.table.tabs.delete": "Удалить",
  "machines.table.tabs.rename": "Переименовать",
  "machines.table.tabs.select_action": "Выберите действие",
  "machines.table.tabs.move": "Переместить",
  "machines.table.tabs.copy": "Скопировать",

  "machines.table.tabGroups.inactive": "Неактивные",
  "machines.table.tabGroups.inactive.title": "Неактивные майнеры",
  "machines.table.tabs.all_tab": "Все",
  "machines.table.tabs.all_tab.title":
    "Отображаются все учётные записи майнеров кроме 'Выбывших'",
  "machines.table.tabs.racks_tab": "На полке",
  "machines.table.tabs.racks_tab.title":
    "Отображаются учётные записи майнеров, расположенные на полках",
  "machines.table.tabs.active_tab": "Активные",
  "machines.table.tabs.active_tab.title":
    "Майнеры, которые в настоящий момент работают",
  "machines.table.tabs.problem_tab": "Проблемные",
  "machines.table.tabs.problem_tab.title":
    "Отображаются записи майнеров с хешрейтом ниже номинала, но не офлайн",
  "machines.table.tabs.offline_tab": "Отключенные",
  "machines.table.tabs.offline_tab.title": "Отключенные майнеры",
  "machines.table.tabs.incorrectid_tab": "Неверный ID",
  "machines.table.tabs.incorrectid_tab.title":
    "ID полки указанный в майнере не совпал с ID указанным в панели (Login: Miner_ID.ID_полки)",
  "machines.table.tabs.service_tab": "Сервис",
  "machines.table.tabs.service_tab.title":
    "При переносе майнера в эту вкладку он сохраняет свой текущий ID, полку, и продолжает находиться в других вкладках",
  "machines.table.tabs.store_tab": "Склад",
  "machines.table.tabs.store_tab.title":
    "При переносе майнера сюда он освобождает полко-место и меняет ID",
  "machines.table.tabs.retired_tab": "Выбывшие",
  "machines.table.tabs.retired_tab.title":
    "При переносе майнера сюда он удаляется из всех системных вкладок и меняет ID",
  "machines.table.tabs.unknown_tab": "Неизвестные",
  "machines.table.tabs.unknown_tab.title":
    "Майнеры с неизвестным MinerID (направляются на пул админа по умолчанию)",

  "machines.table.tabs.select.title": "Раздел",
  "machines.table.tabs.select.addStatus": "Добавить раздел",

  "machines.table.tabs.hide_other_miners":
    "Спрятать оборудование из других вкладок",
  "machines.actions": "Действия",
  "machines.actions.configure": "Настроить выбранные",
  "machines.actions.delete": "Удалить выбранные",
  "machines.actions.move": "Переместить",
  "machines.actions.print": "Распечатать QR-коды",
  "machines.actions.configure.hint": "Настроить выбранные майнеры",
  "machines.actions.delete.hint": "Удалить выбранные майнеры",
  "machines.actions.move.hint": "Переместить выбранные майнеры",
  "machines.actions.print.hint": "Распечатать QR-коды для выбранных майнеров",
  "machines.actions.delete.confirm.1":
    "Вы уверены, что желаете удалить # майнеров?",
  "machines.actions.delete.confirm.2":
    "Вы уверены, что желаете удалить # майнера?",
  "machines.actions.delete.confirm.3":
    "Вы уверены, что желаете удалить # майнер?",
  "machines.actions.delete.error": "Ошибка!",
  "machines.actions.delete.error.hint":
    "При удалении майнеров произошли следующие ошибки:",

  //miner ID field
  "machines.miner_row.miner_id.hint":
    'Используйте "-" для авторасположения. \n Пример: 001-C001-001A11',
  "machines.miner_row.miner_id.confirm_change": `Вы хотите сохранить новый ID "{newId}" ?`,
  "machines.miner_row.miner_id.eqaul_id": `Этот id майнера уже существует`,
  "machines.miner_row.miner_id.restore": `Вернуть майнер на полку`,
  "machines.miner_row.error_hint": "Майнер работает со сбоями",
  "machines.miner_row.unknown_id": "ID в панели не совпадает с ID в майнере",

  //more
  //plan
  "plan.title": "План:",
  "plan.paused": "Пауза",
  "plan.from": "от:",
  "plan.until": "до:",
  "machines.more.individualChart": "График",
  "machines.more.settings": "Настройки",
  "machines.more.control": "Управление",
  "machines.more.clone_settings": "Копировать",
  "machines.more.clone_settings_title": "Клонированные Настройки",
  "machines.more.hashrate.title": "Хэшрейт",
  "machines.more.settings.messages.title": "Ваши сообщения",
  "machines.more.settings.messages.title_admin": "Сообщения",
  "machines.more.settings.messages.title_user": "Сообщения",
  "machines.more.settings.messages.placeholder": "Введите сообщение",
  "machines.more.settings.messages.empty": "нет сообщений",
  "machines.more.settings.messages.moscow_time": "Московское время",
  "machines.more.settings.messages.field": "Сообщение",
  "machines.more.settings.messages.btn": "Отправить",
  "machines.more.settings.personal.title": "Личные заметки администратора",
  "machines.more.settings.personal.title_user": "Личные заметки пользователя",
  "machines.more.settings.personal.title_sync": "Синхронизированные заметки",
  "machines.more.settings.personal.field": "Сделайте заметки",
  "machines.more.settings.personal.unsaved": "Не сохранено",
  "machines.more.settings.personal.btn": "Сохранить",
  "machines.more.settings.miner_errors.title": "Технические ошибки",
  "machines.more.settings.miner_errors.subtitle": "История ошибок",
  "machines.more.settings.miner_errors.col-1": "Код",
  "machines.more.settings.miner_errors.col-2": "Тип",
  "machines.more.settings.miner_errors.col-3": "Пояснения",
  "machines.more.settings.miner_errors.col-4": "Дата",
  "machines.more.admin_table.title": "Майнер сменит пул на",
  "machines.more.serial.title": "Серийный номер",
  "machines.more.model.title": "Модель майнера",
  "machines.more.instalation_date.title": "Дата установки майнера",
  "machines.more.photos.title": "Фото майнера",
  "machines.more.serial.bage": "№",
  "machines.more.model.bage": "мод.",
  "machines.more.photos.empty": "Загрузите фото майнера (не более 5)",
  "machines.more.settings.personal_note": "Личная заметка",
  "machines.more.settings.ip": "IP",
  "machines.more.settings.mac": "MAC",
  "machines.more.settings.port": "Порт",
  "machines.more.settings.password": "Пароль",
  "machines.more.settings.data_fields.edit": "Изменить",
  "machines.more.settings.data_fields.save": "Сохранить",
  "machines.more.settings.data_fields.reset": "Отмена",
  "machines.more.settings.data_fields.ucp_no_contract_error": "Майнеру не применен контракт",
  "machines.more.settings.data_fields.append_to_comment": "Добавить в заметки",
  "machines.more.settings.ip.validation": "Пример: 10.1.12.88",
  "machines.more.settings.mac.validation": "Пример: CA:05:17:00:09:F9",
  "machines.more.settings.port.validation": "Пример: [001-21]",
  "machines.more.settings.password_switch": "Пароль контракта",
  "machines.more.settings.select_contract.label": "Контракт",
  "machines.more.settings.select_plan.label": "План",
  "machines.more.settings.select_plan.disabled_hint": "Выберите контракт",
  "machines.more.settings.minerData.requestSave.title":
    "Сохранить изменения в данных майнера?",
  "machines.more.settings.minerData.requestSave.fields": "Измененные поля:",
  "machines.more.setinngs.confirm.remove_plan.title":
    "Из майнера будет удален план",
  "machines.more.setinngs.confirm.remove_plan.subtitle":
    "После этого, майнер необходимо включить вручную. Продолжить?",

  //CLIENTS PAGE
  "clients.title": "Пользователи",
  "clients.technicals.title": "Техники",
  "clients.add_new": "+ Добавить нового",
  "clients.create_tech_user": "Создать техника",
  "clients.table.id": "ID",
  "clients.table.email": "Эл. почта",
  "clients.table.role": "Роль",
  "clients.table.customer": "Имя",
  "clients.table.comment": "Комментарий",
  "clients.table.code": "Код получения майнера",
  "clients.table.link": "Ссылка на вход",
  "clients.table.2fa": "2FA",
  "clients.table.online": "Включены",
  "clients.table.low": "Статус low",
  "clients.table.offline": "Выключены",
  "clients.table.summ": "Всего",
  "clients.table.color": "Цвет",
  "clients.table.row.enter_as_user": "войти как пользователь",
  "clients.table.row.2fa_yes": "Да",
  "clients.table.row.2fa_no": "Нет",
  "clients.table.row.more.btn.hash": "Хешрейт",
  "clients.table.row.more.btn.state": "Состояние",
  "clients.table.row.more.chart.hash": "Хешрейт",
  "clients.table.row.more.chart.state": "Состояние",
  "clients.table.row.empty": "Список пользователей пуст",
  "clients.table.row.new_tags": "Добавить тэг",
  "clients.table.row.tags.delete": "Удалить тэг",
  "clients.table.empty": "Список пользователей пуст",
  "clients.table.row.contracts.title": "Контракты",
  "clients.table.row.contracts_has": "Доступные",
  "clients.table.row.contracts_signed": "Подписанные",
  "clients.table.row.more.download": "Сгенерировать отчет",
  "clients.table.row.more.download.progress": "Загрузка отчета...",
  "clients.table.row.more.download.info": "Ваш отчет формируется...",
  "clients.table.row.more.download.info2":
    "Пожалуйста, не покидайте страницу и выбранного пользователя.",
  "clients.comments.error.incorrect": "Некорректная строка",
  "clients.comments.error.incorrect_max": "Максимальная длина строки 100 символов",


  //SETTINGS PAGE
  "settings.title": "Настройка",
  "settings.templates.title": "Шаблоны пулов",
  "settings.templates.title.create": "Создать шаблон",
  "settings.option.1": "Пул 1",
  "settings.option.2": "Пул 2",
  "settings.option.3": "Пул 3",
  "settings.option.address": "Адрес",
  "settings.option.login": "Логин",
  "settings.option.password": "Пароль",
  "settings.option.divider": "Делитель",
  "settings.btn.used": "Исп. для {count} майнеров",
  "settings.btn.used.empty": "Не используется",
  "settings.btn.default.title": "Default",
  "settings.btn.default.hint": "Установить дефолтную настройку",
  "settings.add_new_pool": "Добавить настройку",
  "settings.controls.edit": "Редактировать",
  "settings.controls.cancel": "Отмена",
  "settings.controls.delete": "Удалить",
  "settings.select_pool": "Выберите настройки пула",

  //LOCATIONS PAGE
  "locations.title": "Локации",
  "locations.table.name": "Название",
  "locations.table.id": "ID",
  "locations.table.address": "Адрес",
  "locations.table.appKey": "Ключ локации",
  "locations.table.coords": "Координаты",
  "locations.table.notes": "Записи",
  "locations.add_new": "+ Добавить локацию",
  "locations.empty": "Список локаций пуст",
  "locations.delete_confirm":
    "Все строения и шкафы удалятся, а майнеры перейдут в список нераспределённых. Продолжить?",
  "locations.buildings.delete_confirm":
    "Все шкафы удалятся, а майнеры перейдут в список нераспределённых. Продолжить?",
  //location more
  "location.__delete": "Удалить",
  "location.building": "ID строения:",
  "location.building.info.cancel": "Отмена",
  "location.building.add_new": "+Объект",
  "location.building.address": "Адрес:",
  "location.building.graph": "Хэшрейт",
  "location.additional_title.available_racks": "Шаблоны шкафов",
  "location.additional_title.available_equipment": "Список элементов",
  "location.rackTable.rotate": "Развернуть",
  "location.rackTable.align": "Упорядочить",
  "location.rackTable.rotate.title":
    "Показать подключенное оборудование майнеров",
  "location.rackTable.align.title": "Выровнять по левому краю",
  "location.available_racks.empty": "Нет доступных шаблонов",
  "location.available_racks.create": "Добавить новый шаблон",
  "location.rackTable.rack.edit": "Изменить",
  "location.clients.title": "Клиенты:",
  "location.unnalocated.title": "Список нераспределенных майнеров:",
  "location.unnalocated.empty": "Нет майнеров",
  "location.equipment.network": "Сеть",
  "location.equipment.electrical": "Электричество",
  "location.available_equipment.connect_all": "Подключить все майнеры",
  "location.available_equipment.title": "Оборудование",
  "location.available_equipment.network": "Сеть",
  "location.available_equipment.electrical": "Электричество",
  "location.equipment.connection_info.placeholder":
    "Дополнительная информация ({type})",
  "location.equipment.connection_info.apply": "Добавить",
  "location.equipment.connection_info.cancel": "Отмена",
  "location.rackTable.rack.sure_delete":
    "Вы действительно хотите удалить шкаф?",
  "location.rackTable.rack_template.sure_delete":
    "Вы действительно хотите удалить шаблон шкафа?",
  "location.rackTable.rack.no_undo": "Отменить удаление будет невозможно",
  "location.rack.rack_item.back.equipment.sure_change":
    "Вы дуйствительно хотите заменить оборудование?",
  "location.rack.rack_item.back.equipment.sure_delete":
    "Вы уверены, что хотите удалить оборудование?",
  "location.rack.rack_item.info": "Инфо",
  "location.rack.rack_item.delete": "Убрать",
  // "location.rack.rack_item.delete_confirm": 'Удалить майнер "{name}" ?',
  "location.rack.rack_item.delete_confirm": "Убрать майнер из ячейки?",
  "location.rack.confirm_save_rackId":
    "Вы не сохранили новый ID шкафа. Сохранить?",
  //ACCOUNT PAGE
  "account.title": "Аккаунт",
  "account.add": "Добавить новый {type}",
  "account.userCode": "Ваш идентификатор для передачи майнера",
  "account.controllerId": "Код админа для контроллера",

  //RESTORE PAGE
  "restore.btn": "Восстановить",

  //MANAGE PAGE
  "contracts.title": "Управление",
  "contracts.btn.name_contracts": "Контракты",
  "contracts.btn.name_plans": "Планы",
  "contracts.btn.name_profiles": "Профили майнеров",
  "contracts.btn.name_parts": "Запчасти",
  "contracts.btn.name_tags": "Радиометки",
  "contracts.selector.lable": "Выберите контракт",
  "contracts.selector.edit": "Изменить",
  "contracts.selector.edit__cancel": "Отменить",
  "contracts.selector.delete": "Удалить",
  "contracts.selector.delete_contract": "Удалить контракт",
  "contracts.selector.clearing_option": "Без контракта",
  "contracts.selector.cannot_save_plan":
    "Сначала сохраните контракт для майнера",
  "contracts.create_new": "Создать контракт",
  "contracts.plan.create_new": "Создать план отключений",
  "contracts.plan.delete_plan": "Удалить план",
  "contracts.info.name": "Название",
  "contracts.info.client": "Клиент",
  "contracts.info.password": "Пароль",
  "contracts.info.electro_cost": "Стоимость электричества, кВтч",
  "contracts.info.electro_cost__bage": "руб.",
  "contracts.plan_info.plans_selector.placeholder": "Добавьте планы",
  "contracts.plan_info.title": "Детали плана:",
  "contracts.plan_info.used_in_contracts": "Используется в контрактах:",
  "contracts.plan_info.applied": "Применим к: ",
  "contracts.plan_info.applied.time.week": "Неделе",
  "contracts.plan_info.applied.time.month": "Календарю",
  "contracts.plan_info.periods.title": "Временные периоды",
  "contracts.plan_info.mining_descr":
    "В невыделенные дни майнинг идет в течении всего дня",

  "contracts.files.too_large": "Файл слишком большой",

  "manage.plan_info.periods.title__1": "В",
  "manage.plan_info.periods.title__2": "Добавить интервал",
  "manage.plan_info.template.title": "Шаблон",
  "manage.plan_info.template.confirm": "Вы хотите перезаписать шаблон?",
  "manage.plan_info.template.delete_confirm": "Вы хотите удалить шаблон?",
  "manage.plan_info.delete_plan": "Вы уверены что хотите удалить план?",
  //"manage.plan_info.plan_used": "Использовать план:",
  "manage.plan_info.skip": "Пропустить",
  "manage.plan_info.now": "Сейчас",
  "manage.plan_info.used_plan": "Используется план:",
  "manage.plan_info.unused_plan": "Не используется план:",
  "manage.plan_info.interval": "Интервал:",
  "manage.plan_info.attention": "Внимание!",
  "manage.plan_info.skip_interval_deletion": "Интервал(ы) после пропуска и/или перед ним будут удалены. Продолжить?",
  "manage.plan_info.error_time_after_time": "Время окончания должно быть после времени начала",
  "manage.plan_info.error.two_empty":
    "Период {period} содержит два пустых значения",
  "manage.plan_info.error.multiple_cross_empty_start":
    "Обнаружено более одного перехода на следующий день",
  "manage.plan_info.error.incorrect_cross_next_day":
    "Обнаружен некорректный переход на следующий день",
  "manage.plan_info.error.multiple_cross_empty_end":
    "Обнаружено более одного перехода на следующий день",
  "manage.plan_info.error.incorrect_cross_multiple":
    "Некорректный переход между днями: не может быть несколько переходов",
  "manage.plan_info.error.incorrect_format_start":
    "Неверный формат времени начала в периоде {period}: {start}",
  "manage.plan_info.error.incorrect_format_end":
    "Неверный формат времени окончания в периоде {period}: {end}",
  "manage.plan_info.error.incorrect_period_greater":
    "Неверный период в {period}: {start} > {end}",
  "manage.plan_info.error.incorrect_periods_not_close":
    "Присутствуют незакрытые периоды",
  "manage.plan_info.error.crossed_periods":
    "Периоды пересекаются: {periods0} и {periods1}",

  "contracts.conditions.title": "Условия контракта:",
  "contracts.plan.select_plan": "Выберите план",
  "contracts.btn.save": "Сохранить",
  "contracts.btn.cancel": "Отменить",
  "manage.create.profile": "Создать профиль",
  "manage.selector.profile": "Выберите профиль",
  "manage.profile.width": "Ширина",
  "manage.profile.height": "Высота",
  "manage.profile.depth": "Глубина",
  "manage.profile.params.unit": "{value} {unit}",
  "manage.profile.volume": "Объем",
  "manage.profile.delete.title": "Вы хотите удалить профиль?",
  "manage.profile.delete.error": "Профиль используется в майнерах: ",
  "manage.parts.title": "Запчасти",
  "manage.parts.in_stock": "В наличии",
  "manage.parts.in_use": "Используются",
  "manage.parts.discarded": "Удаленные",
  "manage.parts.create": "Создать",
  "manage.parts.table.head.photo": "Фото",
  "manage.parts.table.head.part_name": "Название",
  "manage.parts.table.head.id": "ID",
  "manage.parts.table.head.owner": "Владелец",
  "manage.parts.table.head.location": "Локация",
  "manage.parts.table.head.SAP_ID": "SAP ID",
  "manage.parts.table.head.created": "Создан",
  "manage.parts.table.head.comments": "Записи",
  "manage.tags.title": "Шаблоны",
  "manage.tags.managment.add_tag": "Добавить шаблон",
  "manage.tags.managment.delete_template": "Удалить шаблон",
  "manage.tags.managment.template_name": "Название",
  "manage.tags.managment.templateDetails":
    "К данному шаблону привязаны метки: ",
  "manage.tags.reports.title": "Отчеты по меткам",
  "manage.tags.reports.reportDate": "Дата отчета",
  "manage.tags.managment.templates.title": "Шаблоны меток",
  "manage.tags.managment.selectTag": "Выберите шаблон",
  "manage.tags.managment.measurement_add": "Добавить параметр",
  "manage.tags.managment.measurement.title": "Параметр №{num}",
  "manage.tags.managment.template_radiolabels.title": "Радиометки шаблона",
  "manage.tags.managment.template_radiolabels.item.name": "Имя",
  "manage.tags.managment.template_radiolabels.item.location": "Локация",
  "manage.tags.managment.template_radiolabels.item.serial": "Серийный номер",
  "manage.tags.managment.template_radiolabels.item.params": "Параметры",
  "manage.tags.managment.template_radiolabels.item.delete": "Удалить",
  "manage.tags.managment.template_radiolabels.item.edit": "Изменить",
  "manage.tags.managment.reports.filter.rfid": "Радиометки",
  "manage.planslist.active_plan": "Активный план:",
  "manage.planslist.contracts": "Контракты:",
  "manage.planslist.intervals": "Интервалы:",

  "manage.planslist.warning.intervals_disabled_all": "Отключатся все редактируемы дни недели для данного плана. Продолжить?",
  "manage.planslist.warning.intervals_enabled_all": "Включатся все редактируемы дни недели для данного плана. Продолжить?",

  "manage.planslist.week_excluded": "Не используется",
  "manage.planslist.week_unused": "Переопределено",

  "manage.planinfo.editor": "Редактор",
  "manage.planinfo.plans_list": "Список планов",
  "manage.planinfo.ranges_off": "Неактивно",

  //MESSENDGER PAGE
  "messenger.tabs.admin": "Чат с администратором",
  "messenger.tabs.support": "Чат с поддержкой",
  "messenger.tabs.users": "Чат с пользователями",
  "messenger.tabs.admins": "Чат с администраторами",
  "messenger.input.placeholder": "Введите ваше сообщение здесь…",
  "messenger.message.you": "Вы",

  //NOTIFICATIONS PAGE
  "notifications.channels.general": "Уведомления",
  "notifications.channels.title": "Каналы уведомлений",
  "notifications.channels.tg.notConnected": "Телеграм-бот не подключен",
  "notifications.channels.tg.connect": "Подключить",
  "notifications.channels.email.notVerified": "Почта не подтверждена",
  "notifications.channels.email.verify": "Подтвердить",
  "notifications.channels.apple.push": "Пуш",
  "notifications.channels.apple.ios": "Только iOS",
  "notifications.channels.connected": "Подключено",
  "notifications.channels.condition.hashrateBelow": "Хешрейт ниже",
  "notifications.channels.condition.rejects": "Отказов более",
  "notifications.channels.condition.andOr": "и/или",
  "notifications.channels.condition.fromDefault": "от номинального",
  "notifications.channels.message.title": "Сообщение",
  "notifications.groups.title": "Группы уведомлений",
  "notifications.groups.createGroup": "Создать новую группу",
  "notifications.groups.table.head.name": "Имя",
  "notifications.groups.table.head.status": "Статус",
  "notifications.groups.table.head.numberOfMiners": "Количество майнеров",
  "notifications.groups.table.head.hashrateBelow": "Хешрейт ниже",
  "notifications.groups.table.head.rejects": "Отказы",
  "notifications.groups.table.head.channels": "Каналы",
  "notifications.groups.table.head.reportTime": "Время отчета (UTC)",
  "notifications.groups.table.data.status.active": "Активный",
  "notifications.groups.table.data.status.inactive": "Не активный",
  "notifications.groups.table.data.hashrateBelow.fromDefault":
    "от номинального",
  "notifications.groups.group.head.minerId": "ID майнера",
  "notifications.groups.group.head.type": "Тип",
  "notifications.groups.group.head.state": "Состояние",
  "notifications.groups.group.head.currentHashrate": "Текущий хешрейт",
  "notifications.groups.group.head.defaultHashrate": "Хешрейт по умолчанию",
  "notifications.groups.group.head.hashrateBelow":
    "Уведомлять, когда хешрейт ниже (TH/s)",
  "notifications.groups.group.head.settings": "Индивидуальные настройки",
  "notifications.history.title": "История уведомлений",
  "notifications.history.tools.selectDate": "Дата",
  "notifications.history.tools.selectGroup": "Группа",
  "notifications.history.table.head.date": "Дата",
  "notifications.history.table.head.groupName": "Имя группы",
  "notifications.history.table.head.channels": "Каналы",
  "notifications.history.table.head.status": "Статус",
  "notifications.channelName.email": "Почта",
  "notifications.channelName.push": "Пуш",
  "notifications.channelName.tg": "Телеграм",

  //Transliting component
  "transliting_tooltip.text": "Русский буквы были заменен на Английские",

  //NOTIFICATIONS
  //success
  "notifications.success": "Успешно",
  "notifications.check_email":
    "Ссылка на подтверждение отправлена на вашу почту",
  "notifications.user_created": "Пользователь создан",
  "notifications.email.verified": "Пароль подтвержден",
  "notifications.password.restored": "Пароль восстановлен",
  "notifications.copied": "Скопировано",
  "notifications.saved": "Сохранено",
  "notifications.cleared": "Очищено",
  "notifications.loading": "Загрузка...",
  //errors
  "notifications.error.fill": "Пожалуйста, заполните поля",
  "notifications.error.match": "Пароли должны совпадать",
  "notifications.error.length": "Длина пароля должна быть больше 6 символов",
  "notifications.error.name": "Поле обязательно для заполнения",
  "notifications.error.password": "Введите ваш личный пароль",
  "notifications.error.symbols": "Запрещены спец. символы и символы кириллицы",
  "notifications.error.duplicate_params":
    "Имена параметров должны быть уникальными",
  "notifications.error.miner_settings.fill": "Сначала заполните настройку",
  "notifications.error.miner_settings.miners": "Сначала выберите майнеры",
  "notifications.error.search.length": "должно быть больше 2-х символов",
  "notifications.error.add_pool_setting.protocol": `Пожалуйста, проверьте правильность ввода адреса. 
  Пример - stratum+tcp://stratum.test.com:3333`,
  "notifications.error.add_pool_setting.check":
    "Пожалуйста, проверьте, что все поля заполнены правильно. В противном случае ваш майнинг может прерваться или работать некорректно",
  "notifications.error.add_pool_setting.some_errors": "Некоторые поля не заполнены или заполнены некорректно",
  "notifications.error.miner_plan.name": "Введите название плана",
  "notifications.error.miner_plan.length":
    "Название плана должно быть больше 3х символов",
  "notifications.error.miner_plan.days": "Выберите хотя бы 1 день",
  "notifications.error.miner_plan.period_default":
    "У вас уже есть период [00:00 - 23:59]",
  "notifications.error.miner_plan.periods":
    "Один или более периодов пересекаются",
  "notifications.error.locations.sameId":
    "Вы не можете создавать локации с одинаковыми ID.",
  "notifications.error.locations.fill_fields":
    "Пожалуйста, заполните отмеченные поля.",
  "notifications.error.locations.more.delete_rack":
    "Вы не можете удалить шкаф с майнерами внутри",
  "notifications.error.locations.more.edit_rack":
    "Вы не можете изменить шкаф, так как его новый размер удалит установленные майнеры",
  "notifications.error.locations.more.rack_section": "Выберите больше 1 секции",
  "notifications.error.locations.more.merge":
    "Вы не можете увеличивать майнер, потому что размер превышает доступный размер шкафа",
  "notifications.error.locations.more.merge_lower_zero":
    "Вы не можете увеличить майнер. Увеличение должно быть под манером или за ним.",
  "notifications.error.location.rackItem.move":
    "Вы не можете расположить майнер тут",
  "notifications.error.unnalocated.unmerge":
    "Сначала необходимо удалить расширенные секции для майнера",
  "manage.tags.managment.error.tag_name_too_short":
    "Имя шаблона должно содержать минимум 5 символов",
  "manage.tags.managment.error.tag_name_too_long":
    "Длина имени шаблона не может превышать 100 символов",
  "notifications.error.locations.rack.name_already_in_use": "Имя шкафа уже используется",
  "notifications.error.locations.rack.wrong_name_format": "Неверный формат имени шкафа",


  //info
  "notifications.info.delete": "Удалить",
  "notifications.info.registration": "Почта подтверждена",
  "notifications.info.timer.title": "Пожалуйста, дождитесь окончания таймера",
  "notifications.info.timer.hasTimers":
    "Пожалуйста, дождитесь окончания работы таймера в майнерах:",

  //selectors
  "selector.all": "Все",
  //more/less
  "more.closed": "Больше",
  "more.opened": "Меньше",
  //inputSelector , pool and fields (prev\current)
  "change_setting.current": "Установленный:",
  "change_setting.prev": "Предыдущий:",
  "change_setting.admin_setting": "Настройка админа",
  "change_setting.user_pools": "Пулы пользователя:",
  "change_setting.admin_mining_is_on": "Заблокировано майнингом на админа",
  //adminSettings
  "admin_settings.custom": "Свое значение",
  //table sorting (saved\cleared)
  "table_sorting.title.saved": "Сохранить фильтрацию и сортировку",
  "table_sorting.title.cleared": "Удалить фильтрацию и сортировку",
  //algorithm
  "algo.label": "Алгоритм",
  "algo.all": "Все",
  "algo.error": "Не указана настройка пула",
  //plan time
  "plan_time.from": "От:",
  "plan_time.until": "До:",
  //selector (miner plan)
  "selector.miner_plan.create": "Создать",
  "selector.miner_plan.view": "Изменить",
  "selector.miner_plan.clear": "Очистить",
  "selector.plan.default": "Без плана",
  //chart hashrate
  "chart_hash.period": "Период",
  "chart_hash.time_zone": "Часовой пояс: Москва",
  "chart_hash.empty_data": "График пуст",
  "chart_hash.last_info.speed_now": "Текущая скорость:",
  "chart_hash.last_info.speed": "Скорость: ",
  "chart_hash.last_info.time": "Время: ",
  "chart.scale": "Масштаб",
  //chart state
  "chart_state.total": "Всего:",
  "chart_state.empty_filtered": "Нет отфильтрованных майнеров",
  "chart_state.last_change": "Последнее изменение:",
  "chart_state.speed": "Скорость: ",
  "chart_state.search.clear": "Очистить",
  "chart_state.search.empty": "Нет майнеров с этим ID",
  "chart_state.search.placeholder": "Майнер #",
  "chart_state.miner_id": "Майнер #",
  "chart_state.time": "Время: ",
  "chart_state.empty_data": "График пуст",
  "chart.hashrate": "Скорость",
  "chart.reject_rate": "Процент отказов",
  // RateDropSelector
  "rate_drop.unset": "Не установлено",
  "rate_drop.speed_drop": "падения скорости",
  "rate_drop.speed_drop_info":
    "выбрать майнеры, для которых хэшрейт упал на {percent}% и более.",
  "mining_percent.unset": "Не установлено",
  "mining_percent.less_than": "менее",

  // MODALS
  // modal order a call
  "modal.header.title": "Оставить заявку",
  "modal.header.subtitle":
    "Заполните контактные данные, наш менеджер свяжется с Вами!",
  "modal.name": "Имя",
  "modal.email": "Эл. почта",
  "modal.phone": "Телефон",
  "modal.telegram": "Имя пользователя Telegram",
  "modal.textarea": "Комментарий",
  "modal.textarea.placeholder":
    "Вы можете написать о типе ваших устройств, моделях, количестве или оставить любой комментарий.",
  "modal.btn": "Отправить",
  "modal.btn.loading": "Отправка...",
  "modal.choice.title": "Выберите:",

  // add pool modal
  "modal.pool.title": "Добавить настройку",
  "modal.pool.title_edit": "Изменение настройки",
  "modal.pool.title_proxy": "Настройки пулов",
  "modal.pool.name": "Название настройки",
  "modal.pool.confirm_text":
    "Я соглашаюсь, что все введено верно и хочу продолжить сохранение настройки",
  "modal.pool.btn.cancel": "Отмена",
  "modal.pool.btn.save": "Сохранить",
  "modal.pool.address_required": "Адрес обязателен для заполнения",
  "modal.pool.address_incorrect": "Адрес некорректен",
  "modal.pool.login_required": "Логин обязателен для заполнения",
  "modal.pool.password_required": "Пароль обязателен для заполнения",

  //add new client modal
  "modal.new_client.title": "Добавить клиента",
  "modal.new_client.email": "Эл. почта",
  "modal.new_client.password": "Пароль",
  "modal.new_client.generate": "Сгенерировать пароль",
  "modal.new_client.save": "Создать",

  //add miners table tab modal
  "modal.new_miners_tab.title": "Добавить раздел",
  "modal.new_miners_tab.titleRename": "Переименовать раздел",
  "modal.new_miners_tab.input_name": "Введите имя раздела",
  "modal.new_miners_tab.add": "Добавить",
  "modal.new_miners_tab.rename": "Переименовать",

  // add new location modal
  "modal.location.title": "Добавить локацию",
  "modal.location.title_edit": "Изменение локации",
  "modal.location.btn.cancel": "Отмена",
  "modal.location.btn.save": "Сохранить",
  "modal.location.name": "Название",
  "modal.location.id": "ID",
  "modal.location.address": "Адрес",
  "modal.location.coords": "Координаты на карте",
  "modal.location.notes": "Записи",
  "modal.location.help.1": "Наведите мышь на объект",
  "modal.location.help.2": "Нажмите правкой кнопкой",
  "modal.location.help.3": "Скопируйте координаты в меню",
  "modal.location.help.4": "Вставьте их сюда",

  // confirm modal
  "modal.confirm.title": "Вы уверены?",
  "modal.confirm.btn.yes": "Да",
  "modal.confirm.btn.no": "Нет",
  "modal.confirm.btn.cancel": "Отмена",
  "modal.confirm.delete": "Удалить {name}?",

  // error modal
  "modal.error.title": "Ошибка!",
  "modal.error.btn.ok": "OK",

  //delete miner modal
  "modal.delete_miner.title": "Удаление майнера {miner}",
  "modal.delete_miner.sure":
    "Это действие приведет к удалению майнера и всех его настроек. Продолжить?",
  "modal.delete_miner.btn.cancel": "Отменить",
  "modal.delete_miner.btn.continue": "Продолжить",

  //start\stop mining
  "modal.start_miming.one": "Запустить майнер {miner}?",
  "modal.stop_mining.one": "Оставновить майнер {miner}?",
  "modal.start_miming": "Запустить майнеры?",
  "modal.stop_mining": "Остановить майнеры?",
  "modal.booston_mining": "Включить буст майнера {miner}?",
  "modal.boostoff_mining": "Выключить буст майнера {miner}?",
  "modal.check_mining.one": "Проверить майнер {miner}?",
  "modal.check_mining.all":
    "Cейчас будет выполнена проверка только выбранных майнеров. Если вы хотите выполнить проверку всех майнеров, то очистите выбранные майнеры и попробуйте снова. Продолжить?",
  "modal.booston_mining.all": "Включить буст майнеров?",
  "modal.boostoff_mining.all": "Выключить буст майнеров?",
  "modal.check_mining.all.all":
    "Cейчас будет выполнена проверка всех майнеров. Если вы хотите выполнить проверку определенных майнеров, то выберите их ниже. Продолжить?",
  //forgot modal
  "modal.forgot.title": "Забыли пароль?",
  "modal.forgot.email": "Эл. почта",
  "modal.forgot.send": "Отправить",

  //two fa modal
  "modal.2fa.title": "Google 2FA",
  "modal.2fa.title_reset": "Восстановить Google код",
  "modal.2fa.reset_code": "Код восстановления",
  "modal.2fa.google_code": "Ввести Google 2FA код",
  "modal.2fa.lost_code": "Забыли свой код ?",
  "modal.2fa.return": "Назад",
  "modal.2fa.confirm": "Подтвердить",

  //QR modal
  "modal.qr.title":
    "Отсканируйте этот код с помощью камеры телефона, чтобы подписаться на уведомления.",
  "modal.qr.bottom": "Или, вы можете скопировать код и ввести его тут",

  // create 2FA modal
  "modal.create_2fa.title":
    "Пожалуйста, сохраните этот код в безопасном месте. Вы не сможете войти, если потеряете его.",
  "modal.create_2fa.restore": "Это ваш код восстановления:",
  "modal.create_2fa.loose": "Используйте его, если потеряете QR-код.",
  //create plan modal
  "modal.create_plan.title": "Создать план отключений",
  "modal.create_plan.delete": "Удалить план",
  "modal.create_plan.plan.name": "Название",
  "modal.create_plan.plan.apply_title": "Применимо к:",
  "modal.create_plan.plan.days_not_checked":
    "В дни, которые не отмечены, майнинг идет всегда.",
  "modal.create_plan.plan.except": "Майнинг идет всегда, кроме:",
  "modal.create_plan.btn.apply": "Применить",
  "modal.create_plan.btn.create": "Создать",
  //add email modal
  "modal.add_email.title": "Добавить новую электронную почту для уведомлений",
  "modal.add_email.email": "Эл. почта",
  "modal.add_email.apply": "Добавить",
  // edit account modal
  "modal.edit_account.title": "Настройки аккаунта",
  "modal.edit_account.app_photo": "Доб. фото",
  "modal.edit_account.name": "Имя",
  "modal.edit_account.2fa_text": "Двухфакторная аутентификация",
  "modal.edit_account.email": "Эл. почта аккаунта",
  "modal.edit_account.private": "приватный",
  "modal.edit_account.public": "публичный",
  "modal.edit_account.new_password": "Новый пароль",
  "modal.edit_account.repeat_password": "Повторите новый пароль",
  "modal.edit_account.telegram": "Телеграм",
  "modal.edit_account.about": "О вас",
  "modal.edit_account.summary.title":
    "Отправлять уведомления по выключенным майнерам на:",
  "modal.edit_account.summary.email": "Эл. почту (все аккаунты)",
  "modal.edit_account.summary.telegrams": "Телеграм (все аккаунты)",
  "modal.edit_account.password":
    "Введите свой текущий пароль, чтобы подтвердить изменения",
  "modal.edit_account.save": "Сохранить",

  //create object modal
  "modal.create_object.title": "Добавить новый объект",
  "modal.create_object.building_id": "ID Объекта",
  "modal.create_object.btn": "Создать",

  //equipment modal
  "modal.equipment.create": "Создание оборудования",
  "modal.equipment.edit": "Изменение оборудования",
  "modal.equipment.edit.name": "Название оборудования:",
  "modal.equipment.choose": "Выберите тип оборудования:",
  "modal.equipment.notes.placeholder": "Дополнительнная информация",
  "modal.equipment.notes.color": "Цвет",
  "modal.equipment.btn_save": "Сохранить",

  // rack modal
  "modal.rack.title.edit": "Изменить шкаф",
  "modal.rack.title.edit_available": "Изменить шаблон шкафа",
  "modal.rack.title.create": "Создать новый шаблон",
  "modal.rack.select.type": "Выберите тип шкафа",
  "modal.rack.select.own": "Создайте свой собственный тип",
  "modal.rack.warning.remove_miners": "Для изменения ID шкафа уберите все майнеры с полок",
  "modal.rack.label.enter_rack_id": "Введите ID шкафа",

  //change client password modal
  "modal.change_pass.title": "Изменение пароля пользователя",
  "modal.change_pass.placeholder": "Введите новый пароль",
  "modal.change_pass.save": "Сохранить",
  "modal.change_pass.cancel": "Отменить",

  //create contract modal
  "modal.create_contract.title": "Создание контракта",

  //create miner profile
  "modal.create_profile.title": "Создание профиля майнера",

  // edit template modal
  "modal.editTemplate.title.add": "Создать шаблон",
  "modal.editTemplate.title.edit": "Переименовать шаблон",
  "modal.editTemplate.title.name": "Имя шаблона",
  "modal.editTemplate.title.enterName": "Введите имя",
  "modal.editTemplate.actions.deleteTemplate": "Удалить шаблон",
  "modal.editTemplate.actions.add": "Создать",
  "modal.editTemplate.actions.save": "Сохранить",
  "modal.editTemplate.actions.cancel": "Отмена",

  // edit general notifications
  "modal.editGeneralNotifications.title": "Настройки уведомлений",
  "modal.editGeneralNotifications.title.email": "Почта",
  "modal.editGeneralNotifications.title.tg": "Телеграм-бот",
  "modal.editGeneralNotifications.title.message": "Сообщение",
  "modal.editGeneralNotifications.title.hashrateBelow": "Хешрейт ниже",
  "modal.editGeneralNotifications.title.from": "От",
  "modal.editGeneralNotifications.title.rejects": "Отказов",
  "modal.editGeneralNotifications.buttons.save": "Сохранить",
  "modal.editGeneralNotifications.buttons.cancel": "Отмена",

  // edit notification group
  "modal.editNotificationGroup.title.create": "Создать группу",
  "modal.editNotificationGroup.title.edit": "Редактировать группу",
  "modal.editNotificationGroup.title.name": "Имя",
  "modal.editNotificationGroup.title.hashrateBelow": "Хешрейт ниже",
  "modal.editNotificationGroup.title.from": "От общей скорости",
  "modal.editNotificationGroup.title.rejects": "Отказов более",
  "modal.editNotificationGroup.title.status": "Статус",
  "modal.editNotificationGroup.title.status.active": "Активный",
  "modal.editNotificationGroup.title.status.inactive": "Не активный",
  "modal.editNotificationGroup.title.sendingMode": "Режим отправки отчета",
  "modal.editNotificationGroup.title.timeSlots": "Временные интервалы (UTC):",
  "modal.editNotificationGroup.title.timeSlots.details": "Отправлять отчеты в определенное время (например, каждый день в 09:00 UTC).",
  "modal.editNotificationGroup.title.triggered": "Срабатывание по порогу",
  "modal.editNotificationGroup.title.triggered.details": "Отправлять отчеты, когда производительность ниже установленного порога.",
  "modal.editNotificationGroup.title.notificationChannels": "Каналы уведомлений",
  "modal.editNotificationGroup.title.email": "Почта",
  "modal.editNotificationGroup.title.tg": "Телеграм",
  "modal.editNotificationGroup.title.push": "Пуш (только iOS)",
  "modal.editNotificationGroup.buttons.deleteGroup": "Удалить группу",
  "modal.editNotificationGroup.buttons.create": "Создать",
  "modal.editNotificationGroup.buttons.save": "Сохранить",
  "modal.editNotificationGroup.buttons.cancel": "Отмена",

  // edit notification miner
  "modal.editNotificationMiner.title": "Майнер",
  "modal.editNotificationMiner.title.selectGroup": "Группа",
  "modal.editNotificationMiner.title.hashrateBelow": "Хешрейт ниже",
  "modal.editNotificationMiner.title.from": "От",
  "modal.editNotificationMiner.title.rejects": "Отказов",
  "modal.editNotificationMiner.buttons.save": "Сохранить",
  "modal.editNotificationMiner.buttons.cancel": "Отмена",

  // assign notification group
  "modal.assignNotificationGroup.title.assign": "Добавить",
  "modal.assignNotificationGroup.title.to": "в",
  "modal.assignNotificationGroup.selectGroup": "Выберите группу",
  "modal.assignNotificationGroup.buttons.assign": "Добавить",
  "modal.assignNotificationGroup.buttons.cancel": "Отмена",

  // move miners modal
  "modal.moveMiners.title": "Переместить майнеры",
  "modal.moveMiners.actions.ok": "Ok",
  "modal.moveMiners.actions.cancel": "Отмена",

  //modal move
  "modal.move.title.in_use": "Переместить в используемые",
  "modal.move.title.stock": "Переместить в наличии",
  "modal.move.title.discarded": "Переместить в удаленные",
  "modal.move.btn": "Переместить",

  //spare parts modal
  "modal.spare_part.title": "Создать запчасть",
  "modal.spare_part.save_template": "Сохранить в шаблонах",
  "modal.spare_part.name.title": "Имя",
  "modal.spare_part.name.owner": "Владелец",
  "modal.spare_part.name.quantity": "Количество",
  "modal.spare_part.name.location": "Локация",
  "modal.spare_part.name.comments": "Комментарии",
  "modal.spare_part.name.upload.template": "Загрузить шаблон",
  "modal.spare_part.name.upload.template_desc": "Выбрать в шаблонах",
  "modal.spare_part.name.upload.template.subtitle":
    "Выберите главное изображение",
  "modal.spare_part.btn.create": "Создать",
  "modal.spare_part.btn.cancel": "Отменить",

  // upload miner photo
  "modal.upload_photo.title": "Загрузите фото майнера",
  "modal.upload_photo.max_count": "Вы можете загрузить не более 5 файлов",
  "modal.upload_photo.drop_text":
    "Нажмите или переместите файл в выделенную область",
  //MINER LOG
  "miner_log.title": "Изменения ID майнеров",
  "miner_log.info": `Майнеры ниже были перемещены. Не забудьте сменить ID в прошивке!`,
  "miner_log.label.prev": "Предыдущий ID майнера",
  "miner_log.label.new": "Новый ID майнера",
  "miner_log.cancel": "Свернуть",
  "miner_log.clear": "Очистить",

  "search_form.search": "Поиск",
  "search_form.machines.help1":
    'Введите "parameter" для поиска точного параметра.',
  "search_form.machines.help2":
    "Введите parameter1, parameter2, используя запятую в качестве разделителя для одновременного поиска нескольких параметров.",
  "state_selector.label.state": "Состояние",

  //SPAREPARTS
  "spareparts.title": "Запчасти",
  "spareparts.miner_id": "ID майнера",
  "spareparts.type": "Запчасть",
  "spareparts.confirm.delete": "Удалить запчасть?",
  "spareparts_types.confirm.delete": "Удалить тип запчасти?",
  "spareparts.tab.title": "Список запчастей",
  "spareparts_type.tab.title": "Типы запчастей",
  // spareparts modals
  "spareparts.modal.add_type.title": "Создать тип запчасти",
  "spareparts.modal.add_type.name": "Название",

  "modal.add_spareparts.title": "Создать запчасть",

  // socket
  "socket.messages.exec_command_sent": 'Команда "{command}" отправлена.',
  "socket.messages.exec_command_success":
    'Команда "{command}" выполнена успешно.',
  "socket.messages.exec_command_fail":
    'Во время выполнения команды "{command}" произошла ошибка.',

  "miners.ports.access_miner": "Доступ к майнеру",
  "miners.ports.list.port": "Порт",
  "miners.ports.list.description": "ID",
  "miners.ports.list.target": "Целевой IP",
  "miners.ports.list.last_active": "Активно",
  "miners.ports.delete_port": "Удалить порт",
  "miners.ports.system_online": "Система активна",
  "miners.ports.system_offline": "Система не работает",

  "contract_and_plan.no_contract": "Без контракта",
  "contract_and_plan.no_plan": "Без плана",

  "socket.status.connected": "Подключен",
  "socket.status.reconnecting": "Подключение...",
  "socket.status.disconnected": "Отключен",

  "roles.title": "Роль",
  "roles.a": "Администратор",
  "roles.m": "Модератор",
  "roles.u": "Пользователь",
  "roles.t": "Техник",
  "roles.g": "Бог",
  "roles.s": "Супер-Администратор",
  "roles.admin": "Хостинг",
  "roles.client": "Клиент",
  "roles.tech": "Техник",

  //COMMON
  "common.add": "Добавить",
  "common.delete": "Удалить",
  "common.save": "Сохранить",
  "common.flag.green": "Зеленый",
  "common.flag.yellow": "Желтый",
  "common.flag.red": "Красный",
  "common.flag.violet": "Фиолетовый",
  "common.flag.black": "Черный",
  "common.flag.orange": "Оранжевый",
  "common.no_items": "Нет записей",
  "common.sort": "Отсортировать",
  "common.disabled": "Отключено",
  "chunk_error_boundary.title": "Загружается новая версия...",
  "chunk_error_boundary.text": "Пожалуйста, подождите",

  "manage.tags.tooltip.id": "ID",
  "manage.tags.tooltip.location": "Локация",
  "manage.tags.tooltip.when": "Дата",
  "manage.tags.tooltip.template": "Шаблон",
  "manage.tags.tooltip.serial": "S/N",
  "manage.tags.all_radiolabels": "Все радиометки",
  "manage.tags.managment.error.measurement_empty":
    "Параметр не может быть пустым",
  "manage.tags.managment.error.measurement_duplicate":
    "Параметры должны быть уникальными",

  "role_switcher.mode": "Роль:",
  "role_switcher.client": "Клиент",
  "role_switcher.hosting": "Хостинг",


  "CustomerSelector.hasNotFoundedUser": "Выбранный пользователь не найден в списке. Пожалуйста, обратитесь к разработчику.",
  "CustomerSelector.back_to_owner": "Владельцу (забрать майнер у клиента)",
  "CustomerSelector.miners_count": "майнеров",
};
